import React from "react";
import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import {
  CURRENCY_NAME,
  CUSTOM_SELECT_STYLES,
  PUSH_NOTIFICATION_MODULE,
  SELECT_BOX_THEME,
  SUBSCRIPTION_MODULE_TYPE,
  SUPPORTED_PAYMENT_METHOD_LIST,
} from "../../constants";
import Select from "react-select";
import { addSubscriptionAction } from "../../actions/subscription";
import { useDispatch, useSelector } from "react-redux";
import { createChat } from "../../services/api";
export const paymentLink = (data) => {
  return `<a class="chatPaymentLink" href="javascript:void(0)" slug="${data?.slug}">Admin has requested a payment</a>`
}
export default function CreatePayment({ show, onClose, conversation }) {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch()
  const onCancel = () => {
    reset();
    onClose();
  };
  const { user } = useSelector(state => state.user)
  const onSubmit = async (data) => {
    const allData = {
      planType: { value: SUBSCRIPTION_MODULE_TYPE.CUSTOM, name: "Custom" },
      name: data.planName,
      isActive: true,
      currency: data.currency,
      price: data.price,
      targetAudience: data.targetAudience,
      supportedPaymentMethod: SUPPORTED_PAYMENT_METHOD_LIST,
      smallDescription: "this plan allows you to access premium features, including advanced analytics, priority support, and enhanced email-sending capabilities. Upgrade now to maximize your experience!"
    };

    const result = await dispatch(addSubscriptionAction(allData))
    if (result?.status) {
      const data = paymentLink(result.data)
      const innerValue = `Media message`
      if (innerValue.length === 0) {
        return;
      }


      const attributes = {
        module: PUSH_NOTIFICATION_MODULE.PAYMENTLINK, // Custom attribute
        data: result.data,
        participants: conversation?.participants?.filter(x => x.id !== user?.id).map(x=>x.id),
        message: innerValue
      };
      var channelRes = await createChat(attributes);
      onCancel()
    }
  };
  return (
    <Modal
      show={show}
      onHide={onClose}
      className="companyEdit-modal filter-modal"
    >
      <div className="modal-header pt-2">
        <button
          type="button"
          className="btn-close text-dark close-button"
          onClick={onClose}
        >
          &nbsp;
          {/* <span aria-hidden="true">×</span> */}
        </button>
      </div>
      <div className="modal-body">
        <div className="row">
          <div className="col-6 fieldPadding">
            <label className="labelForm" htmlFor="">
              Purpose*
            </label>
            <Controller
              control={control}
              className="form-control"
              name="planName"
              rules={{ required: true }}
              render={({ field }) => (
                <input
                  maxLength={50}
                  autoComplete="off"
                  {...field}
                  type="text"
                  className="form-control"
                  placeholder="Currency holding plan"
                />
              )}
            />
            {errors.planName?.type === "required" && (
              <span className="errorMessage">
                {" "}
                A product name is required and recommended to be unique.
              </span>
            )}
          </div>
          <div className="col-6 fieldPadding">
            <label className="labelForm" htmlFor="">
              Price*{" "}
            </label>
            <Controller
              control={control}
              className="form-control"
              name="price"
              rules={{ required: true }}
              render={({ field }) => (
                <input
                  {...field}
                  autoComplete="off"
                  type="text"
                  className="form-control"
                  placeholder="Price/Amount"
                />
              )}
            />
            {errors.planName?.type === "required" && (
              <span className="errorMessage"> Price/Amount is required.</span>
            )}
          </div>
          <div className="col-12 fieldPadding">
            <label className="labelForm" htmlFor="">
              Currency*{" "}
            </label>
            <Controller
              name="currency"
              control={control}
              rules={{ required: true }}
              // defaultValue={null}
              render={({ field }) => (
                <Select
                  theme={SELECT_BOX_THEME}
                  styles={CUSTOM_SELECT_STYLES}
                  className="select-border"
                  {...field}
                  options={CURRENCY_NAME}
                  isClearable={true}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  placeholder="Choose currency ..."
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                />
              )}
            />
            {errors.planName?.type === "required" && (
              <span className="errorMessage"> Currency is required.</span>
            )}
          </div>
          <div className="col-12 fieldPadding">
            <label className="labelForm" htmlFor="">
              Description*
            </label>
            <Controller
              control={control}
              name="targetAudience"
              rules={{ required: true }}
              render={({ field }) => (
                <ReactQuill theme="snow" {...field} />
              )}
            />
            {errors.targetAudience?.type === "required" && (
              <span className="errorMessage">
                Brief description of your target demographic (e.g. For
                individuals seeking wealth accumulation...)
              </span>
            )}
          </div>
          <div className="row bottomRow">
            <div className="col-md-6">
              <button
                onClick={onCancel}
                type="button"
                className="btn save-btn cancelButton"
              >
                Cancel
              </button>
            </div>
            <div className="col-md-6 mt-md-0 mt-2">
              <button
                type="submit"
                onClick={handleSubmit(onSubmit)}
                className="btn save-btn customConfirmButton"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
